<template>
  <div ref="wrapper" class="resource_tree__wrapper">
    <div>
      <el-tree
        ref="resourceTree"
        :props="props"
        :load="loadNode"
        node-key="resourceId"
        @node-click="nodeClick"
        lazy
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <i :class="data.icon"></i>
          <span style="margin-left:5px;">{{node.label}}</span>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { COMMON_PROJECT_RESOURCE_LIST } from "@/store/mutation-types";
import BScroll from "better-scroll";
import { SCROLL_CONFIG } from "@/store/constant";

export default {
  name: "ResourceTree",
  data() {
    return {
      props: {
        label: "name",
        isLeaf: "leaf",
        children: "children"
      }
    };
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true
    },
    projectName: String
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([
          {
            name: this.projectName,
            resourceId: this.projectId,
            icon: "el-icon-folder"
          }
        ]);
      }
      this.$store
        .dispatch(COMMON_PROJECT_RESOURCE_LIST, node.data.resourceId)
        .then(data => {
          data.forEach(item => {
            // resourceTypeId : 2 表示该资源为房屋.
            if (item["resourceTypeId"] === 2) {
              item.icon = "el-icon-s-home";
              item.leaf = true;
            } else {
              item.icon = "el-icon-folder";
              item.disable = true;
            }

            if (!item.hasChildren) {
              item.leaf = !item.hasChildren;
              item.icon = "el-icon-s-home";
            }
          });
          resolve(data);
        });
    },

    nodeClick(data) {
      // resourceTypeId : 2 表示该资源为房屋.
      if (data.resourceTypeId === 2) {
        this.$emit("input", data);
      }
    }
  },
  mounted() {
    new BScroll(this.$refs.wrapper, SCROLL_CONFIG);
  }
};
</script>

<style scoped>
.resource_tree__wrapper {
  overflow: hidden;
  height: 400px;
}
</style>